import { Component, OnInit, NgZone } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';
import { DynamicSnacbarErrorComponent } from 'src/app/container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { EmployerService } from 'src/app/services/employer.service';
import { MatDialog } from '@angular/material/dialog';
import { HttpIOService } from 'src/app/services/http-io.service';
import { Helper } from 'src/app/helper/defult';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PopupConfirmationComponent } from 'src/app/container/elements/popup-confirmation/popup-confirmation.component';
import { DynamicSnacbarSkipComponent } from 'src/app/container/elements/dynamic-snacbar-skip/dynamic-snacbar-skip.component';

@Component({
  selector: 'app-sandbox',
  templateUrl: './sandbox.component.html',
  styleUrls: ['./sandbox.component.scss']
})
export class SandboxComponent implements OnInit {
  sandBoxForm: UntypedFormGroup;
  file: { name: string, progress: number, file: File, size: number } | null = null;
  fileToUpload = [];
  emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9_.+-]{2,}$/;
  namePattern = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  jobRolePattern = /^(?! )[A-Za-z0-9\s]*$|^.*[^ ]$/;
  uploadText = "Uploading...";
  allSubscriptionsData: any = [];

  constructor(
    private fb: UntypedFormBuilder,
    private io: HttpIOService,
    private empService: EmployerService,
    private snackBar: MatSnackBar,
    private helper: Helper,
    public dialog: MatDialog,
    private ngZone: NgZone,
  ) { }

  ngOnInit(): void {
    this.formInit();
    this.allSubscriptions();
  }

  formInit() {
    this.sandBoxForm = this.fb.group({
      firstName: ['',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.namePattern),
        ]),
      ],
      lastName: ['',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.namePattern),
        ]),
      ],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.emailPattern),
        ]),
      ],
      jobRole: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.jobRolePattern),
        ]),
      ],
    });

  }

  // Validation Controls
  get f() {
    return this.sandBoxForm.controls;
  }

  async saveCVs() {
    if (this.sandBoxForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.sandBoxForm);
      return false;
    }

    const formData = new FormData();
    formData.append('path', 'upload-file');
    formData.append('purpose', 'parseResume');
    formData.append('file', this.file.file);

    await this.io._uploadFile(formData).subscribe(
      (res: any) => {
        this.fileToUpload.push(res['result'].id + '_' + res['result'].fileName);
        // Takes the CV and parse it
        let payLoad = {
          path: "/public/resume-parser",
          firstName: this.sandBoxForm.value.firstName,
          lastName: this.sandBoxForm.value.lastName,
          email: this.sandBoxForm.value.email,
          jobRoles: this.sandBoxForm.value.jobRole,
          files: this.fileToUpload.map(file => ({
            Key: file,
          })),
        }
        this.empService._parseResumeSandbox(payLoad).subscribe((res: any) => {
          if (res.statusCode == 200) {
            
            let successData = "sandbox CV";
            const dialogRef = this.dialog.open(PopupConfirmationComponent, {
              height: 'auto',
              width: 'auto',
              autoFocus: false,
              data: {
                data: successData,
                firstName: this.sandBoxForm.value.firstName,
              },
            });
            this.file = null;
            this.fileToUpload = [];
            this.sandBoxForm.reset();
            dialogRef.afterClosed().subscribe();
          } else {
            this.snackBar
              .openFromComponent(DynamicSnacbarErrorComponent, {
                data: res.body,
                verticalPosition: 'top', // 'top' | 'bottom'
                horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
                duration: 6000,
              })
              .afterOpened()
              .subscribe(this.helper.setOnTop);
          }
        });

      },
      (err) => console.log(err)
    );

  }


  onFilesSelected(event: any): void {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      this.file = { name: selectedFile.name, progress: 0, file: selectedFile, size: selectedFile.size };
      this.uploadFile();
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    // Add some visual feedback for drag over
    (event.target as HTMLElement).classList.add('drag-over');
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    // Remove visual feedback when drag leaves
    (event.target as HTMLElement).classList.remove('drag-over');
  }

  onFileDropped(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const droppedFile = event.dataTransfer?.files[0];
    if (droppedFile) {
      this.file = { name: droppedFile.name, progress: 0, file: droppedFile, size: droppedFile.size };
      this.uploadFile();
    }
    (event.target as HTMLElement).classList.remove('drag-over');
  }

  uploadFile(): void {
    this.uploadText = "Uploading...";
    const interval = setInterval(() => {
      if (this.file) {
        this.file.progress += 10;
        if (this.file.progress >= 100) {
          this.uploadText = "Upload Complete";
          clearInterval(interval);
        } 
      }
    }, 1000);
  }

  removeFile(): void {
    this.file = null;
  }

  allSubscriptions() {
    let jsonData = {
      path: 'all-subscriptions',
    };
    this.io._getAllSubscription(jsonData).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        this.allSubscriptionsData = res['result'].subscriptions;
      }
    });
  }

  // To add the email on the daily job alerts
  createAlert() {
      if (this.sandBoxForm.status === 'INVALID') {
        this.helper.markFormGroupTouched(this.sandBoxForm);
        return false;
      }
      if (this.allSubscriptionsData.length == 0) {
        this.snackBar
          .openFromComponent(DynamicSnacbarErrorComponent, {
            data: 'Something went wrong ',
            verticalPosition: 'top', // 'top' | 'bottom'
            horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
            duration: 6000,
          })
          .afterOpened()
          .subscribe(this.helper.setOnTop);
        return false;
      }
      let jsonData = {
        path: 'add-user-subscription',
        email: this.sandBoxForm.value.email,
        subscriptions: [this.allSubscriptionsData[3].id],
      };
      let successData = 'daily job alert';
      this.io._updateUserSubscription(jsonData).subscribe((res: any) => {
        if (res.serverResponse.code == 200) {
          // const dialogRef = this.dialog.open(PopupConfirmationComponent, {
          //   height: 'auto',
          //   width: 'auto',
          //   autoFocus: false,
          //   data: {
          //     data: successData,
          //   },
          // });
          // dialogRef.afterClosed().subscribe((res) => {
          // });
        } else if (res.serverResponse.code == 400) {
          this.snackBar
            .openFromComponent(DynamicSnacbarSkipComponent, {
              data: res.serverResponse.message,
              verticalPosition: 'top', // 'top' | 'bottom'
              horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
        }
      });
    }
}
